<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{titles.profileUpdateExpression}}</h4>
                <Tab :currentTab="tabs[0]" :currentTabComponent="currentTab" :form="formComponent"
                     :role="role"
                     :show="showTab"
                     :tabs="tabs"
                     v-if="Object.keys(formComponent).length>0"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {
        email,
        required
    } from 'vuelidate/lib/validators';
    import {titles} from '../../utils/general/titles.js';
    import {roles} from '../../utils/general/roles';
    import Tab from '../common/Tab';
    import {getUser} from '../shared/services/user.service';
    import {commercial} from '../shared/models/commercial';

    export default {
        name: 'Form',
        components: {Tab},
        data() {
            return {
                titles,
                roles,
                currentTab: null,
                showTab: true,
                formComponent: {},
                tabs: [],
                role: this.$store.getters.role
            };
        },
        created() {
            let userForm, passwordForm;
            getUser(this.$store.getters.user.id).then(response => {
                if (this.role == this.roles.admin) {
                    userForm = response.data;
                } else if (this.role == this.roles.client) {
                    userForm = {
                        organisation: {
                            client: {}
                        }
                    };
                    userForm.organisation.client = response.data;
                } else if (this.role == this.roles.commercial) {
                    userForm = commercial(response.data);
                } else {
                    userForm = response.data;
                }
                passwordForm = {
                    oldpassword: null,
                    newPassword: null,
                    newRetypedPassword: null
                };
                this.formComponent = {...userForm, ...passwordForm};
            });
            if (this.role == this.roles.admin) {
                this.tabs = [
                    {
                        name: 'Infos',
                        component: 'AdminInfo'
                    },
                    {
                        name: 'Paramétrage',
                        component: 'SettingsInfo'
                    }
                ];
            } else if (this.role == this.roles.client) {
                this.tabs = [
                    {
                        name: 'Infos',
                        component: 'ClientInfo'
                    },
                    {
                        name: 'Paramétrage',
                        component: 'SettingsInfo'
                    }
                ];
            } else {
                this.tabs = [
                    {
                        name: 'Infos',
                        component: 'CommercialForm'
                    },
                    {
                        name: 'Paramétrage',
                        component: 'SettingsInfo'
                    }
                ];
            }
            this.currentTab = this.$route.params.goToTab ? this.$route.params.goToTab : this.tabs[0].component;
            this.tabSelected = this.tabs[0].component;
        },
        validations() {
            if (this.role == this.roles.admin) {
                return {
                    formComponent: {
                        firstname: {required},
                        lastname: {required},
                        email: {required, email}
                    }
                };
            }

        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/appStyle.css';
</style>
